import { addClass, removeClass } from "../_vars";
export const openFilter = () => {
    const openFilterBtn = document.querySelector(".result-types__filter");
    const filter = document.querySelector(".estate__filter");
    const closeFilterBtn = document.querySelector(".filter__close");
    if (openFilterBtn && closeFilterBtn && filter) {
        openFilterBtn.addEventListener("click", () => {
            addClass(filter, "show");
        });
        closeFilterBtn.addEventListener("click", () => {
            removeClass(filter, "show");
        });
    }
};
